var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { useMemo } from "react";
import { useRem } from "../utils/global";
import "./wrap.css";
var classPrefix = "bbt-react-wrap";
export var Wrap = function (props) {
  var children = props.children,
      styles = props.styles,
      _a = props.className,
      className = _a === void 0 ? "" : _a,
      _b = props.rows,
      rows = _b === void 0 ? 0 : _b,
      _c = props.lineHeight,
      lineHeight = _c === void 0 ? 30 : _c,
      _d = props.spacing,
      spacing = _d === void 0 ? 0 : _d,
      _e = props.runSpacing,
      runSpacing = _e === void 0 ? 0 : _e,
      px2rem = props.px2rem;
  var usePx2rem = useRem(px2rem);
  var content = useMemo(function () {
    if (Array.isArray(children)) {
      return children === null || children === void 0 ? void 0 : children.map(function (child, index) {
        return React.createElement("div", {
          key: index,
          className: "".concat(classPrefix, "-item"),
          style: {
            height: usePx2rem(lineHeight),
            marginBottom: usePx2rem(runSpacing),
            marginRight: usePx2rem(spacing)
          }
        }, child);
      });
    } else {
      return children;
    }
  }, [children, lineHeight, runSpacing, spacing]);
  var maxHeight = useMemo(function () {
    if (rows == 0) return null;
    return usePx2rem(rows * (lineHeight + runSpacing));
  }, [rows, lineHeight, runSpacing]);
  return React.createElement("div", {
    className: "".concat(classPrefix, " ").concat(className),
    style: __assign(__assign({
      maxHeight: maxHeight
    }, styles), {
      marginBottom: runSpacing > 0 ? "-".concat(usePx2rem(runSpacing)) : usePx2rem(runSpacing)
    })
  }, content);
};